import { createTheme, MantineColorsTuple } from '@mantine/core';

// ---------------------------------------------------------------------------
//  Brand Palette — Standard Produce Navy
// ---------------------------------------------------------------------------

const brand: MantineColorsTuple = [
  '#e8edf5',
  '#c5d0e6',
  '#9fb2d4',
  '#7892c0',
  '#5a7ab2',
  '#3d63a4',
  '#1a3a6b',
  '#152f57',
  '#102444',
  '#0b1930',
];

const produce: MantineColorsTuple = [
  '#edf7ee',
  '#d4ecd6',
  '#a8d9ac',
  '#7ac580',
  '#54b35c',
  '#38a344',
  '#2d8a38',
  '#236e2c',
  '#1a5322',
  '#103817',
];

const amber: MantineColorsTuple = [
  '#fff8e1',
  '#ffecb3',
  '#ffe082',
  '#ffd54f',
  '#ffca28',
  '#ffc107',
  '#ffb300',
  '#ffa000',
  '#ff8f00',
  '#ff6f00',
];

const slate: MantineColorsTuple = [
  '#f8f9fb',
  '#eef0f4',
  '#d8dce4',
  '#b5bcc9',
  '#9da6b6',
  '#84909f',
  '#6e7a89',
  '#55606e',
  '#3e4754',
  '#1a1f28',
];

// ---------------------------------------------------------------------------
//  Theme
// ---------------------------------------------------------------------------

export const theme = createTheme({
  primaryColor: 'brand',
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontWeight: '700',
  },
  colors: {
    brand,
    produce,
    amber,
    slate,
  },
  defaultRadius: 'md',
  cursorType: 'pointer',
  shadows: {
    xs: '0 1px 2px rgba(0,0,0,0.04)',
    sm: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)',
    md: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -1px rgba(0,0,0,0.04)',
    lg: '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -2px rgba(0,0,0,0.04)',
    xl: '0 20px 25px -5px rgba(0,0,0,0.08), 0 10px 10px -5px rgba(0,0,0,0.03)',
  },
  components: {
    Paper: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
        p: 'md',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
      styles: {
        root: {
          fontWeight: 600,
          transition: 'all 150ms ease',
        },
      },
    },
    Modal: {
      defaultProps: {
        radius: 'lg',
        centered: true,
        overlayProps: { backgroundOpacity: 0.35, blur: 4 },
        shadow: 'xl',
      },
    },
    Table: {
      styles: {
        th: {
          fontSize: '0.7rem',
          fontWeight: 700,
          textTransform: 'uppercase' as const,
          letterSpacing: '0.05em',
          color: 'var(--mantine-color-dimmed)',
        },
      },
    },
    NavLink: {
      styles: {
        root: {
          borderRadius: 'var(--mantine-radius-md)',
          transition: 'all 150ms ease',
        },
      },
    },
    Badge: {
      defaultProps: {
        radius: 'sm',
        variant: 'light',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    AppShell: {
      styles: {
        main: {
          backgroundColor: 'var(--mantine-color-slate-0)',
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: 'sm',
        radius: 'md',
      },
    },
    Skeleton: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
});
